<template>
    <div>
        <div class="cards-container">
            <div v-for="user in subuser_statistic" :key="user.id" class="user-stat-card"> 
                <div class="user-info">
                    <span class="user-dot"></span>
                    <span class="user-name">{{user.name}}</span>
                </div>
                <div class="user-stats">
                    <div class="stat-item">
                        <span class="stat-number1">{{user.offers_count}}</span>
                        <span class="stat-label">{{ $t('statistics.text_13') }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number2">{{formatPrice(user.total_price)}} €</span>
                        <span class="stat-label">{{ $t('statistics.text_14') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-container">
            <div class="table-container-scroll">
                <div class="table-container-title">
                    <span class="name_space">{{ $t('statistics.text_15') }}</span>
                    <span v-for="month in last12Months" :key="month.id">
                        {{ month }}
                    </span>
                </div>
                <div class="table-container-data">
                    <div v-for="subuser in subuser_monthly_statistic" :key="subuser.id" class="table-container-item">
                        <div class="item_avatar"> {{initials(subuser.name)}} </div>
                        <div class="tooltip_name item_name" v-if="subuser.name !== truncatedName(subuser.name)">
                            <span class="">{{ truncatedName(subuser.name) }}</span>
                            <span class="tooltiptext_name">{{ subuser.name  }}</span>
                        </div>
                        <div class="item_name" v-else>{{ subuser.name  }}</div>
                        <div class="item_months_data">
                            <div v-for="month in sortedMonthlyStats(subuser.monthlyStats)" :key="month.id" class="item_one_month">
                                <span class="offers_count">{{month.count}}</span>
                                <span class="offers_price">{{formatPrice(month.price)}} €</span>
                            </div>
                        </div>
                    </div>
                    <div class="table-container-sumar-item">
                        <div class="sumar_item_name">{{ $t('statistics.text_16') }}</div>
                        <div class="sumar_item_months_data">
                            <div  v-for="item in sortedMonthlyStats(subuser_monthly_statistic_price)" :key="item.id" class="sumar_item_one_month">
                                {{formatPrice(item)}} €
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['subuser_statistic', 'subuser_monthly_statistic', 'subuser_monthly_statistic_price'],
    data() {
        return {
            allMonths: [
                this.$t('statistics.january'), 
                this.$t('statistics.february'), 
                this.$t('statistics.march'), 
                this.$t('statistics.april'), 
                this.$t('statistics.may'), 
                this.$t('statistics.june'), 
                this.$t('statistics.july'), 
                this.$t('statistics.august'), 
                this.$t('statistics.september'), 
                this.$t('statistics.october'), 
                this.$t('statistics.november'), 
                this.$t('statistics.december')
            ]
        }
    },
    methods: {
        sortedMonthlyStats(monthlyStats) {
            const keys = Object.keys(monthlyStats);
            const sortedKeys = keys.sort((a, b) => parseInt(b) - parseInt(a)).reverse();
            const sortedObject = {};
            sortedKeys.forEach(key => {
                sortedObject[key] = monthlyStats[key];
            });
            return sortedObject;
        },
        formatPrice(value) {
            let val = (value/1).toFixed(0).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        },
        truncatedName(name) {
            return name.length > 10 ? name.substring(0, 10) + '...' : name;
        },
        initials(name) {
            return name
                .split(' ')
                .map(part => part.charAt(0).toUpperCase())
                .join('');
        },
    }, 
    computed: {
        last12Months() {
            const currentMonthIndex = new Date().getMonth();
            const monthsBeforeCurrent = this.allMonths.slice(0, currentMonthIndex+1);
            const monthsAfterCurrent = this.allMonths.slice(currentMonthIndex+1);
            return [...monthsAfterCurrent, ...monthsBeforeCurrent];
        }
    }
}
</script>

<style lang="scss" scoped>
    .tooltip_name {
        position: relative;
        display: inline-block;
        cursor: pointer;
    }

    .tooltip_name .tooltiptext_name {
        visibility: hidden;
        width: auto;
        background-color: #f0f0f0;
        color: #333;
        text-align: left;
        padding: 8px;
        border-radius: 4px;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 0;
        opacity: 0;
        transition: opacity 0.2s;
    }

    .tooltip_name:hover .tooltiptext_name {
        visibility: visible;
        opacity: 1;
    }
.table-container{
    width: 100%;
    overflow-x: auto; 
    white-space: nowrap; 
    margin-top: 36px;
    display: flex;
    padding-bottom: 14px;
    margin-bottom: 60px;
    .table-container-scroll{
        width: 1356px;
    }
    .table-container-data{
        .table-container-item{
            display: flex;
            align-items: center;
            border-radius: 6px;
            background: var(--White, #FFF);
            height: 48px;
            padding-left: 10px;
            margin-bottom: 10px;
            .item_months_data{
                display: flex;
                align-items: center;
                .item_one_month{
                    width: 100px;
                    display: flex;
                    flex-direction: column;
                    span{
                        color: var(--Blue, #212541);
                        font-family: Montserrat;
                        font-size: 10px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 15px; /* 150% */
                    }
                }
            }
            .item_avatar{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 30.904px;
                height: 30px;
                flex-shrink: 0;
                border-radius: 191.25px;
                background: rgba(249, 60, 52, 0.12);
                color: var(--Orange, #F93C34);
                text-align: center;
                font-family: Montserrat;
                font-size: 12px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                margin-right: 9px;
            }   
            .item_name{
                width: 100px;
                color: var(--Blue, #212541);
                font-family: Montserrat;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }
        .table-container-sumar-item{
            display: flex;
            align-items: center;
            height: 48px;
            padding-left: 16px;
            border-radius: 6px;
            background: var(--White, #FFF);
            box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.12);
            .sumar_item_name{
                width: 133px;
                color: var(--Blue, #212541);
                font-family: Montserrat;
                font-size: 11px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
            .sumar_item_months_data{
                display: flex;
                align-items: center;
                .sumar_item_one_month{
                    width: 100px;
                    color: var(--Blue, #212541);
                    font-family: Montserrat;
                    font-size: 11px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                }
            }
        }
    }
    .table-container-title{
        display: flex;
        align-items: center;
        margin-bottom: 14px;
        margin-left: 16px;
        .name_space{
            width: 133px;
        }
        span{
            width: 100px;
            color: var(--gray-400, #9CA3AF);
            font-family: Montserrat;
            font-size: 10px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
    }
    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #CDCDCD;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #abaaaa;
    }
    &::-webkit-scrollbar-track {
        background-color: #EFEFEF;
        border-radius: 5px;
        box-shadow: inset 0 0 5px white;
    }
}
.cards-container {
    display: flex; 
    overflow-x: auto; 
    white-space: nowrap; 
    padding-bottom: 9px;
    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #CDCDCD;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #abaaaa;
    }
    &::-webkit-scrollbar-track {
        background-color: #EFEFEF;
        border-radius: 5px;
        box-shadow: inset 0 0 5px white;
    }
    margin-top: 30px;
}
.user-stat-card {
    flex: 0 0 auto;
    padding: 15px;
    border-radius: 6px;
    background: var(--White, #FFF);
    width: 205px;
    height: 94px;
    flex-shrink: 0;
    margin-right: 15px;
    display: flex;
    flex-direction: column;
    .user-info {
        display: flex;
        align-items: center;
        .user-dot {
            width: 4px;
            height: 4px;
            background: red; 
            border-radius: 4px;
        }
        .user-name {
            color: var(--Blue, #212541);
            font-family: Montserrat;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-bottom: 0;
            margin-left: 5px;
        }
    }
    .user-stats {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-top: 10px;
        .stat-item {
            display: flex;
            flex-direction: column;
            .stat-number1 {
                color: var(--Blue, #212541);
                font-family: Montserrat;
                font-size: 24px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
            .stat-label {
                color: var(--Blue, #212541);
                font-family: Montserrat;
                font-size: 10px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }         
            .stat-number2 {
                color: var(--Blue, #212541);
                font-family: Montserrat;
                font-size: 10px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
        }
    }
}
</style>